import { render } from "./NotFound.vue?vue&type=template&id=cbbe4528"
const script = {}

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__